import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import {
    DateField,
    EditButton,
    translate,
    NumberField,
    TextField,
    BooleanField,
    ReferenceField
} from 'react-admin';

const listStyles = theme => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: '0.5rem 0',
    },
    cardTitleContent: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cardContent: theme.typography.body1,
    cardContentRow: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        margin: '0.5rem 0',
    },
});

const MobileGrid = ({ classes, ids, data, basePath, translate }) => (
    <div style={{ margin: '1em' }}>
        {ids.map(id => (
            <Card key={id} className={classes.card}>
                <CardHeader
                    title={
                        <div className={classes.cardTitleContent}>
                            <span>
                                {translate(`resources.stockinrequests.fields.product`)}:&nbsp;
                                <ReferenceField
                                    label="Product"
                                    source="productId"
                                    reference="products"
                                    record={data[id]}
                                    basePath={basePath}
                                >
                                </ReferenceField>
                            </span>
                            <EditButton
                                resource="commands"
                                basePath={basePath}
                                record={data[id]}
                            />
                        </div>
                    }
                />
                <CardContent className={classes.cardContent}>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.boxes`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="boxes"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.qtyInBox`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="qtyInBox"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.weightPerBox`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="weightPerBox"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.qtyInTailBox`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="qtyInTailBox"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.qty`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="qty"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.qtyPending`)}
                        :&nbsp;
                        <NumberField
                            record={data[id]}
                            source="qtyPending"
                            className={classes.total}
                        />
                    </span>
                    <span className={classes.cardContentRow}>
                        {translate(`resources.stockinrequests.fields.estArrivalDate`)}:&nbsp;
                        <DateField record={data[id]} source="estArrivalDate" showTime />
                    </span>
                </CardContent>
            </Card>
        ))}
    </div>
);

MobileGrid.defaultProps = {
    data: {},
    ids: [],
};

const enhance = compose(
    withStyles(listStyles),
    translate
);

export default enhance(MobileGrid);